import {priority} from '@priority-software/priority-proto-api/lib';
import {getJavaScriptObjectGenMsgs} from '../../../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';

export enum BPMStatusCondition {
    TimeField = 3,
    TimeValue = 2,
    Default = 1
}

export const getBPMStatusCondition = (bpmData: priority.netitems.form.IAlertBPM | null) => {
    if (bpmData?.TimeField) {
        return BPMStatusCondition.TimeField;
    } else if (bpmData?.TimeValue) {
        return BPMStatusCondition.TimeValue;
    }
    return BPMStatusCondition.Default;
};

export const prepareTimeConditionOptions = () => {
    const GWT_texts = getJavaScriptObjectGenMsgs();

    return [
        {label: GWT_texts.Fell || 'Fell', value: 1},
        {label: GWT_texts.FallsIn || 'Falls in', value: -1}
    ];
};
